import { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Box } from "@mui/material";
import { loginValidationSchema } from "../../utils/validationSchema";
import { useTheaterUserLogin } from "../../hooks/useUserQueries";
import CustomTextField from "../CustomTextField/CustomTextField";
import PropTypes from "prop-types";
import PrimaryButton from "../PrimaryButton/PrimaryButton";

const { REACT_APP_ENVIRONMENT: ENVIRONMENT } = process.env;

export default function TheaterLoginForm({ colorScheme = "white" }) {
  const [environment, setEnvironment] = useState('');
  const loginMutation = useTheaterUserLogin();
  const initialValues = {
    email: "",
    password: "",
    environment: "",
  };

  useEffect(() => {
    let environment = localStorage.getItem(ENVIRONMENT) ?? '';
    setEnvironment(environment);
  }, []);

  const onChangeEnviroment = (value) => {
    initialValues.environment = value;
    let currentEnvironment = localStorage.getItem(ENVIRONMENT);
    setEnvironment(value);

    if (value !== currentEnvironment) {
      localStorage.setItem(ENVIRONMENT, value);
      window.location.reload();
    }
  };

  const handleSubmit = (values, { setSubmitting }) => {
    loginMutation.mutate(values);
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={loginValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <select
            className="form-select"
            onChange={(e) => {
              onChangeEnviroment(e.target.value);
            }}
            value={environment}
          >
            <option value="">Selecciona el entorno</option>
            <option value="production">Producción</option>
            <option value="test">Pruebas</option>
            <option value="development">Desarrollo</option>
          </select>
          <CustomTextField
            name="email"
            label="Correo electrónico"
            type="email"
            colorScheme={colorScheme}
            required
          />
          <CustomTextField
            name="password"
            label="Contraseña"
            type="password"
            colorScheme={colorScheme}
            showErrorOnChange
            required
          />
          <Box mt={2}>
            <PrimaryButton type={"submit"} disabled={isSubmitting}>
              Iniciar Sesión
            </PrimaryButton>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

TheaterLoginForm.propTypes = {
  colorScheme: PropTypes.oneOf(["white", "black"]),
};
